import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import Journey from "@/components/site/Journey";
import About from "@/components/site/About";
import Books from "@/components/site/Books";
import Programs from "@/components/site/Programs";
import AutomationPlayground from "@/components/site/AutomationPlayground";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import { scrollToId } from "@/hooks/useLenis";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    document.title = "Chirag Khimani · SDET Instructor & QA Automation Architect";
    const meta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    meta(
      "description",
      "Chirag Khimani — Senior QA Automation Architect, SDET Instructor, and AI Automation Consultant. 12+ years, 5,000+ engineers trained, 2 books published."
    );
  }, []);

  useEffect(() => {
    const hash = location.hash?.replace("#", "");
    if (!hash) return;
    const t = window.setTimeout(() => scrollToId(hash), 80);
    return () => window.clearTimeout(t);
  }, [location.hash, location.pathname]);

  return (
    <div className="grain">
      <Navigation />
      <main>
        <Hero />
        <About />
        <Books />
        <Journey />
        <Programs />
        <AutomationPlayground />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
